import { commits } from '@/modules/core/app/helpers/store';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Team } from '/@/modules/team/models/Team';
import EventBus from '@/modules/core/app/helpers/EventBus';
import { TeamEvent } from '@/modules/team/enums/TeamEvent';

export class TeamSessionService extends BaseEntityService<Team> {
  isTeamMemberParam: boolean = false;

  getRoute(): string {
    return Route.TEAMS;
  }

  getModel(): typeof Team {
    return Team;
  }

  setIsTeamMemberParam(value: boolean): this {
    this.isTeamMemberParam = value;

    return this;
  }

  addParams(params?: Params): Params {
    params = params ?? {};

    if (this.isTeamMemberParam) {
      params.isTeamMember = true;
    }

    return params;
  }

  async getEntities(params?: Params): Promise<Team[]> {
    const teams: Team[] = await super.getEntities(params);

    commits.team.setTeams(teams);
    EventBus.signal(TeamEvent.ON_TEAMS_LOADED);

    return teams;
  }
}

export default new TeamSessionService();
